import type { LottieAnimationData } from "./matchCelebrationTypes";

export function cloneLottieData<T>(data: T): T {
  if (typeof structuredClone === "function") {
    return structuredClone(data);
  }
  return JSON.parse(JSON.stringify(data)) as T;
}

export function loadFoundAFittieEnterAnimation(): Promise<LottieAnimationData> {
  return import("@assets/animations/FoundAFittie.json").then((mod) => mod.default as unknown as LottieAnimationData);
}

export function loadFoundAFittieRemovalAnimation(): Promise<LottieAnimationData> {
  return import("@assets/animations/FoundAFittieRemoval.json").then(
    (mod) => mod.default as unknown as LottieAnimationData
  );
}
